module.exports = __webpack_public_path__ + "img/banner_mac.2a1079b8.png";